import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface LoaderState {
  loading: boolean;
  text: string;
  showText: boolean;
}

@Injectable({ providedIn: 'root' })
export class LoaderService {

  private state = new BehaviorSubject<LoaderState>({
    loading: false,
    text: '',
    showText: false
  });

  state$ = this.state.asObservable();

  /**
   * Requests in flight. Several HTTP calls commonly overlap (e.g. a page
   * firing two GETs on init), each pairing its own show()/hide() via the
   * interceptor's finalize. Without this counter, whichever call finished
   * first would hide the loader for everyone else — a fast unrelated
   * request would hide it while a slower one (e.g. vcm-pending-lst, which
   * can take 10-30s) was still pending, exposing the page's empty state
   * before the real data ever patched in.
   */
  private pendingCount = 0;

  show(text = '', showText = false) {
    this.pendingCount++;

    this.state.next({
      loading: true,
      text,
      showText
    });
  }

  hide() {
    this.pendingCount = Math.max(0, this.pendingCount - 1);

    if (this.pendingCount > 0) {
      return;
    }

    this.state.next({
      loading: false,
      text: '',
      showText: false
    });
  }
}
